import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.urls = []
    this.container = document.createElement("div")
    this.container.className = "row g-3 mb-3"
    this.element.after(this.container)
  }

  preview() {
    this.clear()
    this.element.setCustomValidity("")
    for (const file of this.element.files) {
      if (!["image/jpeg", "image/png", "image/webp"].includes(file.type) || file.size > 20 * 1024 * 1024) {
        this.element.setCustomValidity("Каждое фото должно быть JPG, PNG или WebP до 20 МБ.")
        continue
      }
      const column = document.createElement("div")
      column.className = "col-6 col-lg-3"
      const image = document.createElement("img")
      const url = URL.createObjectURL(file)
      this.urls.push(url)
      image.src = url
      image.alt = "Предпросмотр выбранного фото"
      image.className = "img-fluid rounded"
      image.style.maxHeight = "160px"
      const caption = document.createElement("div")
      caption.className = "small text-break mt-2"
      caption.textContent = `${file.name} · ${(file.size / 1024).toFixed(0)} КБ`
      column.append(image, caption)
      this.container.append(column)
    }
  }

  clear() {
    this.urls.forEach(url => URL.revokeObjectURL(url))
    this.urls = []
    this.container.replaceChildren()
  }

  disconnect() {
    this.clear()
    this.container.remove()
  }
}
